module.exports = __webpack_public_path__ + "img/WorldBuildingNewsCaptionFrame.7b398433.png";